const TRANSACTION_TYPES = Object.freeze({
  AWARD: "award",
  REDEEM: "redeem",
  CORRECTION: "correction"
})

/** FE tab scope used to pick list/export paths (not sent as a query param). */
const TRANSACTION_SCOPES = Object.freeze({
  MINE: "mine",
  SCHOOL_WIDE: "schoolWide"
})

/**
 * GET — `apiV8nocache` base is already `/api/v8`.
 *
 * - Staff / "My history": `/pbis/transactions` (+ `/export`)
 * - Admin school-wide history: `/admin/pbis/transactions` (+ `/export`)
 *   (same filters; path selects school-wide — no `scope` query param)
 * - Students: `/student/pbis/points/transactions`
 */
const TRANSACTIONS_API_PATH = "/pbis/transactions"
const ADMIN_TRANSACTIONS_API_PATH = "/admin/pbis/transactions"
const TRANSACTIONS_EXPORT_API_PATH = "/pbis/transactions/export"
const ADMIN_TRANSACTIONS_EXPORT_API_PATH = "/admin/pbis/transactions/export"
const STUDENT_TRANSACTIONS_API_PATH = "/student/pbis/points/transactions"
const SCHOOL_WIDE_POINTS_SUMMARY_API_PATH = "/admin/pbis/reports/points/summary"
const MY_POINTS_SUMMARY_API_PATH = "/pbis/reports/points/summary/mine"
const STUDENT_POINTS_SUMMARY_API_PATH = "/student/pbis/points/summary"

export default {
  TRANSACTION_TYPES,
  TRANSACTION_SCOPES,
  TRANSACTIONS_API_PATH,
  ADMIN_TRANSACTIONS_API_PATH,
  TRANSACTIONS_EXPORT_API_PATH,
  ADMIN_TRANSACTIONS_EXPORT_API_PATH,
  STUDENT_TRANSACTIONS_API_PATH,
  SCHOOL_WIDE_POINTS_SUMMARY_API_PATH,
  MY_POINTS_SUMMARY_API_PATH,
  STUDENT_POINTS_SUMMARY_API_PATH
}
